var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.fromEventId)?_c(_vm.kind == 'div' ? 'div' : 'tr',{tag:"component",staticClass:"alert--background-color--force"},[_c(_vm.kind == 'div' ? 'div' : 'td',{tag:"component",staticClass:"text-red",class:{
      'text-center': _vm.kind == 'cell'
    },attrs:{"colspan":"99"}},[_c('div',{staticClass:"d-flex flex-row justify-center"},[(_vm.kind == 'cell')?_c('v-icon',{staticClass:"mr-1",staticStyle:{"align-self":"flex-start"},attrs:{"color":"red","small":""}},[_vm._v("$iconBell")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n        "+_vm._s(_vm.$t("wallet:EventFinancesPage.prizesTab.dataMissing.badge.alert"))+"\n\n        "),_c('router-link',{staticClass:"text-red bold",staticStyle:{"text-decoration":"underline !important"},attrs:{"to":{
            name: 'EventRegistrationEditPage',
            params: {
              eventId: _vm.item.fromEventId,
              registrationId: _vm.item.results[0].registration.id
            }
          }}},[_vm._v("\n          "+_vm._s(_vm.$t(
              "wallet:EventFinancesPage.prizesTab.dataMissing.regFormLink.text"
            ))+"\n        ")])],1)],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }